<template>
  <div id="aio-media">
    <mu-card class="aio-input">
      <mu-card-actions class="aio-input-header pointer" @click.native="openInput">
        <mu-flexbox justify="flex_start" style="height: 48px">
          <mu-icon value="photo_camera" class="card-left-icon blueIcon" :size="20"></mu-icon>
          <mu-flexbox-item class="left16" v-text="$t('message.cardPhotos')"></mu-flexbox-item>
          <mu-flexbox-item align="right">
            <mu-icon-button
              v-if="!isOpenInput"
              v-tooltip.top="$t('message.addEntryText')"
              class="card-bar-icon blueIcon"
              :icon="isOpenInput ? 'remove_circle_outline' : 'add_circle'"
            ></mu-icon-button>
            <mu-icon-button
              v-if="isOpenInput"
              class="card-bar-icon blueIcon"
              :icon="'remove_circle_outline'"
            ></mu-icon-button>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-card-actions>
      <mu-card-text v-show="isOpenInput">
        <div id="uploadImage" v-bind:class="{bottom: images.length > 0 || isUploadingImage}">
          <mu-raised-button
            labelClass="large"
            id="uploadBtn"
            :label="$t('message.cardPhotosChoosePicture')"
            @click="bindUploadEvent"
            :disabled="isUploadingImage"
            primary/>
          <input
            style="display: none"
            type="file"
            @change="chooseImage"
            accept="image/*"
          >
        </div>
        <div v-if="images.length > 0 || isUploadingImage" class="label bottom">
          <strong v-text="$t('message.cardPhotosAddingPhotos')"></strong>
        </div>
        <div class="loader" v-if="isUploadingImage">
          <mu-circular-progress
            class="uploadProgress"
            style="position:relative; left: 2px;"
            mode="determinate"
            :size="20"
            :value="uploadProgress"
          />
        </div>
        <mu-avatar
          v-for="image, index in images"
          :key="'image-' + index"
          :src="image.image_url"
          style="margin-right: 8px"
          imgClass="progPic"
        ></mu-avatar>
        <avatar-uploader v-if="profileImage" :hideAvatar="true" :imageUrl="profileImage"/>
      </mu-card-text>
    </mu-card>
  </div>
</template>
<script>
  import axios from 'axios';
  import ProfileApi from '../../../../api/Profile/'
  import ImageManager from '../../../../helpers/ImageManager';

  export default {
    name: 'aio-pictures',
    data() {
      return {
        isOpenInput: false,
        uploadProgress: 0,
        profileImage: null,
        images: []
      }
    },
    methods: {
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
      },
      bindUploadEvent() {
        $('#uploadBtn').next().trigger('click');
      },
      chooseImage(event) {
        let self = this, input = event.target;
        if (input.files && input.files[0]) {
          self.uploadImage(input.files[0]);
        }
      },
      uploadImage(file) {
        let self = this, data = new FormData();
        data.append('file', file);
        let config = {
          onUploadProgress: function (progressEvent) {
            self.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        };
        axios.post(ProfileApi.galleryUploadURL(), data, config).then((response) => {
          if (response.data.complete === true) {
            self.images.unshift(response.data.image);
            self.$toastr.success('Success, image added');
            self.uploadProgress = 0;
          }
        }).catch((error) => {
          if (error.data.response) {
            self.$toastr.error(error.data.response.message);
            self.uploadProgress = 0;
          }
        });
      }
    },
    computed: {
      isUploadingImage() {
        let self = this;
        return self.uploadProgress !== 0;
      }
    },
    mounted() {
      let self = this;
      self.scroller = $('.scroller');
    }
  }
</script>
<style lang="less">
  @loaderColor: #6cc4ff;
  #aio-media {
    button#uploadBtn {
      height: 50px;
    }
    .label.bottom {
      font-size: 16px;
      font-weight: 400;
      margin-top: 16px;
    }
    .progPic {
      border-radius: 4px !important;
      box-shadow: none !important;
    }
    .loader {
      background: @loaderColor;
      height: 40px;
      width: 40px;
      padding: 8px;
      border-radius: 4px;
      vertical-align: top;
      display: inline-flex;
      align-items: center;
      text-align: center;
      .mu-circular-progress-determinate-path {
        stroke: white !important;
      }
    }
    .left16 {
      color: #0179d5;
    }
  }
</style>



// WEBPACK FOOTER //
// Pictures.vue?4ac6a5d9